module.exports = __webpack_public_path__ + "img/waiting-on-photo@1x.930c24ec.png";